import { createContext } from 'react'

export const SystemContext = createContext()
export const UserContext = createContext()
export const JsonContext = createContext()
export const DataContext = createContext()
